import React from 'react';
import {
  Wrapper,
  IconWrapper,
  Icon,
  Title,
  Text,
  Dots,
  ButtonWrapper,
  BackButton,
  ForwardButton,
  FinishButton,
} from './elements';

type ChaOnb01DProps = {
  readonly noArrow?: boolean;
  readonly side: string;
  readonly className?: string;
  readonly onCloseClick: () => void;
  readonly title: string;
  readonly text: string;
  readonly currentSlide: number;
  readonly slideCount: number;
  readonly noPrevious?: boolean;
  readonly onPreviousClick?: () => void;
  readonly backText?: string;
  readonly noNext?: boolean;
  readonly onNextClick: () => void;
  readonly nextText: string;
};

export default function ChaOnb01D({
  noArrow,
  side,
  className,
  onCloseClick,
  title,
  text,
  currentSlide,
  slideCount,
  noPrevious,
  onPreviousClick,
  backText,
  noNext,
  onNextClick,
  nextText,
}: ChaOnb01DProps) {
  return (
    <Wrapper noArrow={noArrow} side={side} className={className}>
      <IconWrapper>
        <Icon onClick={onCloseClick} icon={'icon-close'} color={'#fff'} />
      </IconWrapper>
      <Title>{title}</Title>
      <Text>{text}</Text>
      <Dots currentSlideIndex={currentSlide} slideCount={slideCount} />
      <ButtonWrapper>
        <BackButton
          $hide={noPrevious}
          onClick={onPreviousClick}
          icon={'icon-keyboard_arrow_left'}
          themeName={'dark'}
        >
          {backText}
        </BackButton>
        {currentSlide === slideCount ? (
          <FinishButton $hide={noNext} onClick={onNextClick}>
            {nextText}
          </FinishButton>
        ) : (
          <ForwardButton
            $hide={noNext}
            onClick={onNextClick}
            icon={'icon-keyboard_arrow_right'}
            color={'#fff'}
          >
            {nextText}
          </ForwardButton>
        )}
      </ButtonWrapper>
    </Wrapper>
  );
}
